"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Placeholder } from '../Placeholder/Placeholder.web.js';
import { LazyIcons } from '../icons/lazy.js';

var _excluded = ["iconId", "size"];
var LazyIconLoader = function LazyIconLoader(_ref) {
  var iconId = _ref.iconId,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var Icon = LazyIcons[iconId];
  if (!Icon) {
    console.warn("LazyIcon: icon with ID ".concat(iconId, " not found!"));
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: /*#__PURE__*/React.createElement(Placeholder, {
      height: size,
      width: size
    })
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    size: size
  }, props)));
};

export { LazyIconLoader as default };
